export const KPI_ALCOHOL = ({ processedDashboardData, targetDriverTesting, superRestricted, isAlcoholAllowed, handleChangeTab, theme }) => {
    return (
        <div style={{
            background: theme === 'light' ? '#fff' : '#333',
            padding: '25px',
            borderRadius: '15px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
            border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
            position: 'relative',
            overflow: 'hidden',
            cursor: (!superRestricted && isAlcoholAllowed) ? 'pointer' : 'default'
        }}
        onClick={(!superRestricted && isAlcoholAllowed) ? () => handleChangeTab('alcohol-testing') : null}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '4px',
                height: '100%',
                background: (processedDashboardData?.alcoholKpis?.testingPercentage || 0) >= targetDriverTesting ? '#28a745' : '#ffc107'
            }}></div>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                <div>
                    <h4 style={{ color: '#6c757d', fontSize: '13px', fontWeight: '600', textTransform: 'uppercase', margin: '0 0 8px 0', letterSpacing: '0.5px' }}>
                        DRIVER TESTING COMPLIANCE
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span style={{ 
                            fontSize: '36px', 
                            fontWeight: 'bold', 
                            color: (processedDashboardData?.alcoholKpis?.testingPercentage || 0) >= targetDriverTesting ? '#28a745' : '#ffc107',
                            lineHeight: '1'
                        }}>
                            {processedDashboardData?.alcoholKpis?.testingPercentage || 0}%
                        </span>
                        <span style={{
                            fontSize: '18px',
                            color: (processedDashboardData?.alcoholKpis?.testingPercentage || 0) >= targetDriverTesting ? '#28a745' : '#ffc107',
                            fontWeight: '500'
                        }}>
                            {(processedDashboardData?.alcoholKpis?.testingPercentage || 0) >= targetDriverTesting ? '✓' : '⚠'}
                        </span>
                    </div>
                </div>
                <div style={{
                    background: (processedDashboardData?.alcoholKpis?.testingPercentage || 0) >= targetDriverTesting ? 'rgba(40, 167, 69, 0.1)' : 'rgba(255, 193, 7, 0.1)',
                    padding: '12px',
                    borderRadius: '10px',
                    fontSize: '24px'
                }}>
                    🧪
                </div>
            </div>
            
            <div style={{ 
                fontSize: '14px', 
                color: theme === 'light' ? '#6c757d' : '#adb5bd',
                marginBottom: '8px',
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <span>Tested: {processedDashboardData?.alcoholKpis?.driversTested || 0}/{processedDashboardData?.alcoholKpis?.totalDrivers || 0} drivers</span>
            </div>
            
            <div style={{ 
                fontSize: '14px', 
                color: (processedDashboardData?.alcoholKpis?.passRate || 100) >= 95 ? '#28a745' : '#dc3545',
                marginBottom: '12px',
                fontWeight: '500'
            }}>
                Pass Rate: {processedDashboardData?.alcoholKpis?.passRate || 100}%
            </div>
            
            <div style={{ 
                fontSize: '12px', 
                color: (processedDashboardData?.alcoholKpis?.testingPercentage || 0) >= targetDriverTesting ? '#28a745' : '#ffc107',
                fontWeight: '600',
                textTransform: 'uppercase'
            }}>
                Target: ≥{targetDriverTesting}% • {(processedDashboardData?.alcoholKpis?.testingPercentage || 0) >= targetDriverTesting ? 'COMPLIANT' : 'ACTION REQUIRED'} • 28-Day Rolling
            </div>
        </div>
    )
}